import { defineMessages } from "react-intl";

const messages = defineMessages({
  close: {
    id: "drawer.close",
    defaultMessage: "close",
    description: "The label for closing a pop up",
  },
});

export default messages;
